export const UPDATE_SEARCH_BAR = 'UPDATE_SEARCH_BAR'
